const sessionStatuses = {
  new: 'f22011c3-2ae6-4e47-9736-f6d23db3bf5d',
  assigned: '29890cd1-267a-4f89-8066-31260f88607e',
  noshow: '4e3caaed-6539-4524-b513-e668a7b09c86',
  showed: 'fe443a06-e3de-40c1-bfb9-265d0563c1b6',
};
const sessionStatusToColor = ({ id }) => {
  if (id === sessionStatuses.new) return 'gray';
  if (id === sessionStatuses.assigned) return 'blue';
  if (id === sessionStatuses.showed) return 'green';
  if (id === sessionStatuses.noshow) return 'red';
  return '';
};

const appointmentToCalendarEvent = (appointment) => appointment.sessions.map(
  (session) => ({
    start: appointment.startDate,
    end: appointment.endDate,
    resourceId: appointment.location,
    color: sessionStatusToColor(session.status),
    id: session.id,
    title: `${session.user.firstName} ${session.user.lastName}${session.user.companyName ? ` - ${session.user.companyName}` : ''}`,
  }),
);

const appointmentsToCalendarEvents = (appointments) => appointments
  .flatMap(appointmentToCalendarEvent);

const appointmentsToCalendarData = (appointments) => {
  const calendarEvents = appointmentsToCalendarEvents(appointments);
  const resources = calendarEvents.map((e) => e.resourceId);
  return {
    events: calendarEvents,
    resources: [...new Set(resources)].map((r) => ({ id: r, title: r })),
  };
};

export default appointmentsToCalendarData;
